import AppConstants from '../constants/AppConstants';
import { JobsiteReq, JobsiteRes } from '../proxy/proxy';
import { AxiosJobsitesClient } from '../proxy/ProxyClients';

const StoresService = {
  getAllStores: (): Promise<Array<JobsiteRes>> => AxiosJobsitesClient.page({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE
  }).then((resp) => (resp?.items || []).filter((store: JobsiteRes) => !store.isSoftDeleted)),

  getStoreById: (id: number) => AxiosJobsitesClient.get(id)
    .then((resp) => resp),

  createStore: (payload: JobsiteReq) => AxiosJobsitesClient.create(payload),

  updateStore: (id: number, payload: JobsiteReq) => AxiosJobsitesClient.update(id, payload),

  deleteStore: (id: number = 0) => AxiosJobsitesClient.softDelete(id)
};

export default StoresService;
